exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-content .content-table[data-v-3618bf68] {\n  min-width: unset;\n}", ""]);

// exports
